"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import React, { FC, useState } from "react"
import { Text, Image } from "@/elements"
import clsx from "clsx"

const ImageSectionItemFragment = graphql(`
  fragment ImageSectionItem on CreativeWorkPortfolioProject {
    __typename
    id
    title
    thumbnail1290w: thumbnailUrl(width: 1290)
    thumbnailFocalPointX
    thumbnailFocalPointY
    creatorRolesString
  }
`)

interface Props {
  project: FragmentType<typeof ImageSectionItemFragment> | undefined | null
  index: number | undefined
  fourOrLessProjects: boolean
  imageHeightClass: string
  imageWidthClass: string
  showTextOverlay: boolean
}

const TextOverlay: React.FC<{ title: string; subtitle: string }> = ({ title, subtitle }) => {
  return (
    <div
      className="absolute bottom-0 left-0 flex w-full px-4 pb-4 pt-6 transition-opacity duration-300"
      style={{
        background: "linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent)",
      }}>
      <div className="flex flex-col">
        <Text maxLines={1} variant="label" className="text-bg-1">
          {title}
        </Text>
        <Text maxLines={1} variant="label" className="text-bg-3">
          {subtitle}
        </Text>
      </div>
    </div>
  )
}

export const ImageSectionItem: FC<Props> = props => {
  const { index, fourOrLessProjects, imageHeightClass, imageWidthClass, showTextOverlay = false } = props
  const project = useFragment(ImageSectionItemFragment, props.project)
  const xPosition = project?.thumbnailFocalPointX ?? 0.5
  const yPosition = project?.thumbnailFocalPointY ?? 0.5
  const title = project?.title ?? ""
  const subtitle = project?.creatorRolesString ?? ""

  if (fourOrLessProjects) {
    return (
      <div className="relative h-full w-full overflow-hidden rounded-sm bg-bg-2">
        {project?.thumbnail1290w && (
          <Image
            srcSetUrls={{
              sm: project?.thumbnail1290w,
            }}
            className="h-full w-full rounded-sm object-cover"
            alt={index ? `Skrim image ${index + 1}` : "Blank image"}
            style={{
              objectPosition: `${xPosition * 100}% ${yPosition * 100}%`,
            }}
          />
        )}
        {showTextOverlay && (title || subtitle) && <TextOverlay title={title} subtitle={subtitle} />}
      </div>
    )
  } else {
    return (
      <div className={clsx("min-w-0 flex-none overflow-hidden rounded-sm bg-bg-2", imageWidthClass, imageHeightClass)}>
        <div className="relative flex h-full w-full shrink-0">
          {project?.thumbnail1290w && (
            <Image
              srcSetUrls={{
                sm: project?.thumbnail1290w,
              }}
              className="h-full w-full rounded-sm object-cover"
              alt={project?.title ? project?.title : index ? `Project ${index + 1}` : "Blank iamge"}
              style={{
                objectPosition: `${xPosition * 100}% ${yPosition * 100}%`,
              }}
            />
          )}
          {showTextOverlay && (title || subtitle) && <TextOverlay title={title} subtitle={subtitle} />}
        </div>
      </div>
    )
  }
}
